<template>
	<article class="d-overview-list-custom">
		<Component
			:is="PageHero"
			class="d-overview-list-custom__hero"
			:class="{
				'd-overview-list-custom__hero--without-image':
					!header.image && items.length,
			}"
			v-bind="{ ...header, breadcrumb }"
		/>
		<div v-if="items.length" class="bg-primary px-layout-margin py-xl">
			<div
				class="
					grid
					gap-x-sm gap-y-md
					grid-cols-1
					>=768:grid-cols-2
					>=1024:grid-cols-3
					>=1280:grid-cols-4
				"
			>
				<ContentCard
					v-for="card in items"
					:id="`overview-list-${_uid}-${card.id}`"
					:key="card.key"
					:title="card.title"
					:to="card.url"
					:target="card.target"
					:image="
						isVisualOverviewPage
							? {
									...(card.image || {}),
									aspectRatio: 1.5,
							  }
							: null
					"
					light
				>
					<template #title>
						<BaseH3 tag="h2" v-text="card.title" />
					</template>
				</ContentCard>
			</div>
		</div>

		<div class="mx-layout-margin">
			<Component
				:is="BlockList"
				:block-list="contentElements"
				class="w-full"
			/>
		</div>

		<FeedbackForm v-if="activateFeedback" class="mb-lg" />
	</article>
</template>

<script>
import ContentCard from '~/components/shared/ContentCard';
import FeedbackForm from '~/components/shared/FeedbackForm';

const MainPageHero = () => import('~/components/main/PageHero');
const SubsitePageHero = () => import('~/components/subsite/PageHero');
const MainBlockList = () => import('~/components/main/BlockList');
const SubsiteBlockList = () => import('~/components/subsite/BlockList');

export default {
	name: 'SubsiteOverviewListCustom',

	components: {
		ContentCard,
		FeedbackForm,
	},

	inheritAttrs: false,

	props: {
		title: String,
		contentElements: Array,
		items: Array,
		header: Object,
		breadcrumb: Array,
		isVisualOverviewPage: Boolean,

		activateFeedback: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		PageHero() {
			const map = {
				main: MainPageHero,
				subsite: SubsitePageHero,
			};
			return map[this.$store.state.site.alias] || MainPageHero;
		},
		BlockList() {
			const map = {
				main: MainBlockList,
				subsite: SubsiteBlockList,
			};
			return map[this.$store.state.site.alias] || MainBlockList;
		},
	},
};
</script>

<style lang="postcss">
.d-overview-list-custom {
	@apply bg-primary;
}
.d-overview-list-custom__hero--without-image .c-page-hero__content {
	padding-bottom: 0 !important;
}
</style>
